import { render, staticRenderFns } from "./MatPLDownload.vue?vue&type=template&id=5b47f641&scoped=true&"
import script from "./MatPLDownload.vue?vue&type=script&lang=js&"
export * from "./MatPLDownload.vue?vue&type=script&lang=js&"
import style0 from "./MatPLDownload.vue?vue&type=style&index=0&id=5b47f641&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b47f641",
  null
  
)

component.options.__file = "MatPLDownload.vue"
export default component.exports